import PageShell from "@/components/PageShell";

export default function AboutUs() {
  return (
    <PageShell testid="about-us-page" eyebrow="Our Story" title="Artisan French baking, in Srinagar." updated="26 September 2026">
      <h2>Who we are</h2>
      <p>
        French Pie is an artisan French bakery and pâtisserie. We laminate our own doughs, rest them for 72 hours,
        and bake from the same recipe book at every outlet — every single morning. Our first maison is open at
        Havells Galaxy, Bemina, Srinagar, baking in-house from dawn.
      </p>

      <h2>What we offer</h2>
      <ul>
        <li>Viennoiseries — croissants, pains au chocolat, brioches and turnovers, laminated with French butter.</li>
        <li>Pies &amp; tarts — our namesake La Tourte French Pie, seasonal fruit tarts and mille-feuilles.</li>
        <li>Savory bakes — quiches, ham-and-Comté puffs and stone-baked baguettes.</li>
        <li>Coffee &amp; more — café crème, café gourmand and old-fashioned hot chocolate.</li>
        <li>Celebration cakes and morning pickup reservations ordered through this website.</li>
        <li>Franchise partnerships — one recipe book, full training, and butter, always included.</li>
      </ul>

      <h2>How we bake</h2>
      <p>
        Cold fermentation for 72 hours. Butter by the kilo. No shortcuts, no improvers — a French Pie baker trains
        for months before touching the lamination bench. When a new outlet opens, we don't ship pastries to it; we
        send the craft.
      </p>

      <h2>Visit or write to us</h2>
      <p>
        Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar, Jammu &amp; Kashmir 190018 · Open 10:00 AM – 10:00 PM,
        all days · <strong>bemina@frenchpie.co.in</strong> · +91 95967 66336 · <strong>www.frenchpie.co.in</strong>
      </p>
    </PageShell>
  );
}
